import { ParticipantCompanyName } from "@dune/types";

export const getParticipantCompanyName = (participant: ParticipantCompanyName) => {
  const { society, foreignSociety } = participant;

  if (society) {
    return society.denomination || (society.siren ? `SIREN : ${society.siren}` : "Société sans nom");
  }

  if (foreignSociety) {
    return foreignSociety.denomination || `Immatriculation : ${foreignSociety.registrationNumber}`;
  }

  return '-';
};

export const traductActivities = (activities: string[]) => {
  const englishToFrench: Record<string, string> = {
    "conception": "Conception",
    "autorisation_filing": "Autorisation de dépôt",
    "works_supervision": "Supervision des travaux",
  };


  return activities.map((activity) => {
    if (englishToFrench[activity]) {
      return englishToFrench[activity];
    }

    return activity;
  });
};

export const designerTypeToLabel = {
  ARCHITECTE: "Architecte",
  BUREAU_ETUDE: "Bureau d'étude",
  CONTROLEUR_TECHNIQUE: "Contrôleur technique",
  GEOTECHNICIEN: "Géotechnicien",
  MAITRE_OEUVRE: "Maitre d'oeuvre",
};

export const statusStyles = {
  NEW: "border-blue-badge-border bg-blue-badge-background text-blue-badge-text",
  IN_PROGRESS:
    "border-green-badge-border bg-green-badge-background text-green-badge-text",
  VALIDATED:
    "border-green-badge-border bg-green-badge-background text-green-badge-text",
  CANCELLED:
    "border-red-badge-border bg-red-badge-background text-red-badge-text",
};
